import { useDispatch, useSelector } from 'react-redux'
import Input from '../../../../../UI/Input/Input'
import { setLocal } from '../../../../../../redux/action/local'
import props from '../../../../../../redux/props'

const MezzanineLoan = () => {
  const translations = useSelector((state) => state.translations)
  const purchaseProfile = useSelector((state) => state.PURCHASE_PROFILE)
  const dispatch = useDispatch()

  const update = (key) => (value) => {
    dispatch(setLocal(props.PURCHASE_PROFILE, { ...purchaseProfile, mezzanineLoan: { ...purchaseProfile.mezzanineLoan, [key]: value } }))
    // dispatch(setNewPurchaseProfile({ ...purchaseProfile, mezzanineLoan: { ...purchaseProfile.mezzanineLoan, [key]: value } }))
  }

  return (
    <div className="wrapper">
      <div className="group">
        <div className="label">{translations['my-objects.pipeline.assets-class.mezzanine-loan.from']}</div>
        <div className="values">
          <div className="subgroup">
            <div className="element">
              <Input
                type="customNumber"
                symbol={translations['currency.string']}
                value={purchaseProfile.mezzanineLoan.from}
                onChange={update('from')}
                placeholder={translations['my-objects.pipeline.assets-class.mezzanine-loan.from']}
              />
            </div>
            <div className="element">
              <Input
                type="customNumber"
                symbol={translations['currency.string']}
                value={purchaseProfile.mezzanineLoan.until}
                onChange={update('until')}
                placeholder={translations['my-objects.pipeline.assets-class.mezzanine-loan.until']}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MezzanineLoan
